var YouLi = YouLi ? YouLi : {};
YouLi.Trip = YouLi.Trip ? YouLi.Trip : {};
YouLi.Trip.Schedule = YouLi.Trip.Schedule ? YouLi.Trip.Schedule : {};
YouLi.Trip.Schedule.Response = YouLi.Trip.Schedule.Response ? YouLi.Trip.Schedule.Response : {};

(function (YouLi) {
    (function (Trip) {
        (function (Schedule) {
            (function (Response) {

                let doItemResponse = {
                    itemId: '',
                    inviteeId: '',
                    responseValue: '',
                    element: '',
                    applyToGang: '',
                    callback: null,
                    pricingModel: 0
                }

                YouLi.Trip.Schedule.Response.MultiStateCheckUpdateAndTakeAction = function (checkElement, applyToGang, callback, suppressApplyToGangPrompt) {
                    if ($("#PreviewMode").val() != "True") {
                        var itemId = $(checkElement).data("id");
                        if ($(checkElement).attr("data-state") == "checked")
                            responseValue = "yes";
                        //else if ($(checkElement).attr("data-state") == "crossed")     // YOULI-4868 removing the "crossed" state
                        //    responseValue = "no";
                        else
                            var responseValue = "no";           // YOULI-4868 when transitioning to "unchecked", we mark them as a "no" (not a cleared response)

                        if (!YouLi.Trip.InviteeHasRespondedYes && !YouLi.Trip.IsCurrentUserTripPlanner) {
                            $("#ResponseItineraryItemIncluded").val(itemId);
                            $("#ResponseItineraryItemIncludedAnswer").val(responseValue);
                            $("#ResponseDialogYesExtraNote").show();
                            YouLi.Trip.Program.TargetElementForResponse = checkElement; // grab a hold of this element to allow revert if they cancel the trip response
                            $("#ResponseDialogYes").modal('show');
                        }
                        else {
                            let inviteeId = $(checkElement).data("invitee-id");
                            YouLi.Trip.Schedule.Response.DoItemResponse(itemId, inviteeId, responseValue, checkElement, applyToGang, callback, suppressApplyToGangPrompt);
                        }
                    }
                };

                YouLi.Trip.Schedule.Response.DoItemResponse = function (itemId, inviteeId, responseValue, element, applyToGang, callback, suppressApplyToGangPrompt = false) {
                    const isGang = $('#IsGang:hidden').val();
                    const invoiceMode = $('#InviteeInvoiceMode:hidden').val();
                    const nonDeclinedMemberCount = parseInt($('#GangNonDeclinedMemberCount').val() || '0');
                    doItemResponse.itemId = itemId;
                    doItemResponse.element = element;
                    doItemResponse.inviteeId = inviteeId;
                    doItemResponse.callback = callback;
                    doItemResponse.responseValue = responseValue;
                    doItemResponse.applyToGang = applyToGang;
                    doItemResponse.pricingModel = parseInt($(element).data('pricing-model') || '0');

                    if (responseValue === 'yes'
                        && isGang.toLowerCase() === 'true'
                        && !suppressApplyToGangPrompt
                        && invoiceMode !== "payseparatelyindividual"
                        && nonDeclinedMemberCount > 0) {
                        const isOptionalItem = doItemResponse.pricingModel === 2;
                        $('#AddOnApplyToGangDialog .addon-apply-to-gang-cancel-hint').toggle(!isOptionalItem);
                        $('#AddOnApplyToGangDialog .optional-item-apply-to-gang-cancel-hint').toggle(isOptionalItem);
                        $('#AddOnApplyToGangDialog').modal('show');
                    } else {
                        onDoItemResponse(itemId, inviteeId, responseValue, element, applyToGang, callback);
                    }
                }

                function onDoItemResponse(itemId, inviteeId, responseValue, element, applyToGang, callback) {
                    let targetElement = element;
                    let itineraryTabIsHidden = $("#content-trip-itinerary").hasClass("hidden");
                    let costsTabIsHiddeen = $("#content-trip-paymentdetails").hasClass("hidden");

                    let data = {
                        ScheduleItemId: itemId,
                        CurrentInviteeId: $("#InviteeId").val(),
                        RespondingInviteeId: inviteeId,
                        ResponseValue: responseValue,
                        ApplyToGang: applyToGang
                    };

                    $(".program-item-contents[data-id=" + itemId + "]").addClass("spinner").find(".multistate-check-schedule-item-response").attr("disabled", "");

                    YouLi.Common.Post({
                        url: '/trip/inviteeschedulerespond',
                        params: data,
                        suppressLoading: true,
                        errorCallback: function (response) {
                            $('.program-item-contents[data-id=' + itemId + ']').removeClass('spinner').find('.multistate-check-schedule-item-response').removeAttr('disabled');
                            YouLi.Common.UI.HideLoading();
                            $(targetElement).data('multiStateCheck').revert();

                            var errorMessage = 'An error occurred.';
                            if (response && response.errorMessage)
                                errorMessage = response.errorMessage;

                            YouLi.Common.UI.ShowStandardDialog(errorMessage, 'Error');
                        }
                    }).then(function (response) {
                        $('.program-item-contents[data-id=' + itemId + ']').removeClass('spinner').find('.multistate-check-schedule-item-response').removeAttr('disabled');

                        if (response.url) {
                            YouLi.Common.UI.HideLoading();
                            window.location.href = response.url;
                        } else if (response.success === false) {
                            YouLi.Common.UI.HideLoading();
                            $(targetElement).data('multiStateCheck').revert();

                            var errorMessage = 'An error occurred.';
                            if (response.errorMessage)
                                errorMessage = response.errorMessage;

                            YouLi.Common.UI.ShowStandardDialog(errorMessage, 'Error');
                        } else {
                            $('.multistate-check-schedule-item-response[data-id="' + itemId + '"]').attr('data-state', $(targetElement).attr('data-state'));

                            var programItemElem = $('.program-item-contents[data-id=' + itemId + ']');
                            programItemElem.find('.participants-list').html(response.newParticipantsList);

                            if (responseValue == 'removeresponse')
                                programItemElem.parent().addClass('response-required');
                            else
                                programItemElem.parent().removeClass('response-required');

                            if (responseValue == 'no')
                                programItemElem.parent().addClass('not-going');
                            else
                                programItemElem.parent().removeClass('not-going');

                            YouLi.Trip.UpdateItineraryContent(itineraryTabIsHidden, response.newContentItineraryHtml);
                            YouLi.Trip.Schedule.Response.InitialiseResponseChecks();

                            $('#SelectedCouponCode').val('');
                            $('#payment-detail-content').html(response.newPaymentDetailsHtml);
                            $('.content-trip-heading-details-cost').html(response.newCostSummaryHtml);

                            if ($('.content-trip-paymentdetails-payment-info').length > 0 && response.newPaymentInfoHtml.length > 0)
                                $('.content-trip-paymentdetails-payment-info').html(response.newPaymentInfoHtml);

                            YouLi.Trip.Payments.RefreshPaymentMethod(true);
                            if (!costsTabIsHiddeen)
                                $('#content-trip-paymentdetails').removeClass('hidden');

                            YouLi.Trip.Payments.InitialiseUI();
                            YouLi.Trip.UpdateResponseFooter(runOnce = true, checkTripUpdates = false);
                            YouLi.Trip.Program.SaveDone = true;

                            if (callback) {
                                callback();
                            }
                        }

                    });
                }

                YouLi.Trip.Schedule.Response.InitialiseResponseChecks = function () {
                    $(".schedule-list .multistate-check-schedule-item-response").multiStateCheck({
                        states: ["unchecked", "checked"],
                        onAfterChangeState: function (e) {

                            const applyToGang = true;
                            YouLi.Trip.Schedule.Response.MultiStateCheckUpdateAndTakeAction(e.target, applyToGang, function () {

                                // show (and then hide) notification
                                $(e.target).siblings(".action-done-popover").popover("show"); // use last to get the top-most one (if we're displaying the details)
                                setTimeout(function () {
                                    $(e.target).siblings(".action-done-popover").popover("hide");
                                }, 3000);

                            });
                        }
                    }).each(function () {
                        if ($("#PreviewMode").val() == "True") {
                            $(this).attr("disabled", "");
                        }
                    });
                };

                $(function () {

                    YouLi.Trip.Schedule.Response.InitialiseResponseChecks();

                    $('#AddOnApplyToGangDialog').on('click', '.btn-accept', function () {
                        onDoItemResponse(
                            doItemResponse.itemId,
                            doItemResponse.inviteeId,
                            doItemResponse.responseValue,
                            doItemResponse.element,
                            doItemResponse.applyToGang,
                            doItemResponse.callback
                        );
                        $('#AddOnApplyToGangDialog').modal('hide');
                    });

                    $('#AddOnApplyToGangDialog').on('click', '.btn-decline', function () {
                        if ($(doItemResponse.element).attr("data-state") === "checked") {
                            $(doItemResponse.element).attr("data-state", "unchecked");
                        } else {
                            $(doItemResponse.element).attr("data-state", "checked");
                        }
                    });

                });

            }(YouLi.Trip.Schedule.Response ? YouLi.Trip.Schedule.Response : {}));
        }(YouLi.Trip.Schedule ? YouLi.Trip.Schedule : {}));
    }(YouLi.Trip ? YouLi.Trip : {}));
}(YouLi ? YouLi : {}));